import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text, TextButton } from '@frontend/design-system';

type PopoverMenuSectionProps = {
  title: string;
  onClear?: () => void;
  clearDisabled?: boolean;
  withDivider?: boolean;
  children?: ReactNode;
};

export const PopoverMenuSection = ({
  title,
  onClear,
  clearDisabled,
  withDivider,
  children,
}: PopoverMenuSectionProps) => {
  const { t } = useTranslation('fax');

  return (
    <>
      {withDivider && (
        <div
          css={{ height: 1, width: '100%', backgroundColor: theme.colors.neutral10, marginBottom: theme.spacing(1) }}
        />
      )}
      <div
        css={[
          {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            gap: theme.spacing(1),
            height: 'auto',
            width: '100%',
          },
          !children && disablePopoverMenuItemHoverStyles(clearDisabled),
        ]}
      >
        <div
          css={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: theme.spacing(2),
          }}
        >
          <Text size='medium' color='light' weight='bold'>
            {title}
          </Text>
          {(!!onClear || clearDisabled !== undefined) && (
            <TextButton
              disabled={clearDisabled}
              onClick={onClear}
              css={[
                { fontWeight: 'bold', padding: theme.spacing(0.5), marginRight: theme.spacing(-0.5) },
                !clearDisabled && { color: theme.colors.primary50 },
              ]}
            >
              {t('Clear')}
            </TextButton>
          )}
        </div>
        {children}
      </div>
    </>
  );
};

const disablePopoverMenuItemHoverStyles = (interactionDisabled = true) =>
  css([
    {
      ':hover': {
        backgroundColor: 'inherit',
      },
      ':focus': {
        backgroundColor: 'inherit',
      },
    },
    interactionDisabled && {
      '::before': {
        backgroundColor: theme.colors.neutral20,
      },
    },
  ]);
